import {useCallback} from 'react';
import {Box, Container, Link, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from 'react-router-dom';

function Header() {
  const { t } = useTranslation(); // defaultNS 'transaction'
  const navigate = useNavigate();
  const { lang } = useParams();                  // "en"|"ua"
  const l = (lang === 'ua' ? 'ua' : 'en') as 'en'|'ua';

  const goToHome = useCallback(() => {
    navigate(`/${l}/`, { replace: false });      // keep current lang
  }, [navigate, l]);

  return (
    <Box component='header' sx={{borderBottom: '2px solid #00BFFE'}}>
      <Container>
        <Stack py={1}>
            <Link underline='none' variant='h4' my={3} onClick={goToHome} 
              textTransform={'uppercase'}
              textAlign='center' fontWeight='bold'>
            {t("siteName")}
            </Link>
        </Stack>
      </Container>
    </Box>
  );
}
export default Header;